import "bootstrap/dist/css/bootstrap.css";

import React from "react";
import { Helmet } from "react-helmet";
import ReactDOM from "react-dom";
import App from "./App";
import { store } from "./redux/store";
import { Provider } from "react-redux";

import "popper.js/dist/popper.js";
import "bootstrap/dist/js/bootstrap.js";

import "./styles/index.css";
import "./styles/transition.css";
import "./styles/index-v2.css";
import "./styles/standard.css";
import "./styles/breakpoints.css";
import "./styles/odometer.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "./styles/gradient.css";
import "./styles/smartbanner.css";

// import './styles/scss/main.scss';

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>

        <Helmet>
            <script src="https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js" defer></script>
        </Helmet>
    </React.StrictMode>,
    document.getElementById("root")
);
